var ButtonToggleItemComponent = /** @class */ (function () {
    function ButtonToggleItemComponent() {
    }
    Object.defineProperty(ButtonToggleItemComponent.prototype, "value", {
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ButtonToggleItemComponent.prototype.attach = function (parent) {
        var _this = this;
        if (!this.parent) {
            this.parent = parent;
            this.parent.completed.asObservable().subscribe(function (i) {
                if (_this._value !== i) {
                    _this.isActive = false;
                }
                else {
                    _this.isActive = true;
                }
            });
        }
    };
    ButtonToggleItemComponent.prototype.select = function () {
        if (!this.isDisabled) {
            this.isActive = true;
            this.parent.changeToggle(this._value);
        }
    };
    ButtonToggleItemComponent.prototype.disable = function (isDisabled) {
        this.isDisabled = isDisabled;
    };
    return ButtonToggleItemComponent;
}());
export { ButtonToggleItemComponent };
